import { BirthAnscNotificationsNonResidentCancellationsCrumbs } from 'cancellations/constants/ansc-notifications.crumbs';
import { Fragment, ReactElement } from 'react';
import BirthNonResidentAnscNotificationsShared from 'shell/components/shared/ansc-notifications/detail';
import { IdAmbito } from 'shell/constants/id-ambito';

const AnscNotificationsBirthNonResidentPage = (): ReactElement => {
  return (
    <Fragment>
      <BirthNonResidentAnscNotificationsShared
        scope={IdAmbito.Cancellazioni}
        items={BirthAnscNotificationsNonResidentCancellationsCrumbs()}
      />
    </Fragment>
  );
};

AnscNotificationsBirthNonResidentPage.displayName = 'Ansc Notification edit page component';

export default AnscNotificationsBirthNonResidentPage;
